var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:{'is-short': _vm.isShort},attrs:{"outlined":"","size":_vm.size,"type":_vm.color,"icon-left":_vm.iconLeft,"icon-right":_vm.iconRight,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }